// eslint-disable-next-line import/prefer-default-export
export const fallbackContent = {
  Onboarding: {
    title: 'NextSteps',
    nextSteps: [
      'If you haven’t already verified your identity and email, please check your inbox to confirm your account and follow-up with any additional information requested. Already completed this step? Great job - you’re all set!',
      'Visit your client dashboard and navigate to the Transfer Money tab to fund your new account.',
      'After you move money, check out the account investments on your personalized dashboard.',
    ],
    assetAllocation: {
      goal: 'My Goal:',
      title: 'Here is our investment recommendation for you',
      description: "Based on your answers to the risk profile questions, here's how we recommend you invest your money:",
    },
    accountTypeText: [
      {
        description:
          'This account is useful for all types of investment reasons for a single owner. It has no contribution limits, but it’s subject to annual capital gains.',
        account_type_name: 'Individual',
      },
      {
        description:
          'This type of retirement account allows you to invest your money for the long term and pay taxes later. You may be able to deduct your IRA contributions from your taxes in the year you made the contributions, which lowers your taxable income for that year. You then pay taxes on the money when you withdraw it in retirement (based on your income at the time of withdrawal).',
        account_type_name: 'Traditional IRA',
      },
      {
        description:
          'This type of retirement account allows you to invest your money for the long term and pay taxes now. You contribute using after-tax money (taxes are based on your income at the time of contribution), without deducting those IRA contributions from your taxes. You may then qualify to withdraw your money, tax-free when you reach retirement.',
        account_type_name: 'Roth IRA',
      },
      {
        description:
          'Small business owner? This is the retirement account for you, as it’s tax-deferred and contributions are made by the employer.',
        account_type_name: 'SEP IRA',
      },
      {
        description:
          'While less common, this tax-deferred account is typically offered by small business owners. It lets employees contribute to their retirement savings as part of their pre-tax compensation, and employers can contribute too.',
        account_type_name: 'SIMPLE IRA',
      },
    ],
    address: 'We do not accept a PO Box as a primary street address',
    investmentProfile: {
      cashSweepVehicleChoice: 'Cash Sweep Vehicle Choice:',
      accountStatementDelivery: 'Account Statement Delivery:',
      tradeConfirmationDelivery: 'Trade Confirmation Delivery:',
    },
    congratulationsContent: {
      TD: [
        'If you haven’t already verified your identity and email, please check your inbox to confirm your account and follow-up with any additional information requested. Already completed this step? Great job - you’re all set!',
        'Please check your inbox to complete the DocuSign to finalize your account opening for your {{ accountName }}',
        'Visit your client dashboard and navigate to the Transfer Money tab to fund your new account.',
        'After you move money, check out the account investments on your personalized dashboard.',
      ],
      APEX: [
        'If you haven’t already verified your identity and email, please check your inbox to confirm your account and follow-up with any additional information requested. Already completed this step? Great job - you’re all set!',
        'Visit your client dashboard and navigate to the Transfer Money tab to fund your new account.',
        'After you move money, check out the account investments on your personalized dashboard.',
      ],
      DEFAULT: [
        'If you haven’t already verified your identity and email, please check your inbox to confirm your account and follow-up with any additional information requested. Already completed this step? Great job - you’re all set!',
        'Visit your client dashboard and navigate to the Transfer Money tab to fund your new account.',
        'After you move money, check out the account investments on your personalized dashboard.',
      ],
    },
  },
  ApexAddAccountPage: {
    title: 'AccountTypeText',
    accountTypeText: [
      {
        description:
          'This account is useful for all types of investment reasons for a single owner. It has no contribution limits, but it’s subject to annual capital gains.',
        account_type_name: 'Individual',
      },
      {
        description:
          'This type of retirement account allows you to invest your money for the long term and pay taxes later. You may be able to deduct your IRA contributions from your taxes in the year you made the contributions, which lowers your taxable income for that year. You then pay taxes on the money when you withdraw it in retirement (based on your income at the time of withdrawal).',
        account_type_name: 'Traditional IRA',
      },
      {
        description:
          'This type of retirement account allows you to invest your money for the long term and pay taxes now. You contribute using after-tax money (taxes are based on your income at the time of contribution), without deducting those IRA contributions from your taxes. You may then qualify to withdraw your money, tax-free when you reach retirement.',
        account_type_name: 'Roth IRA',
      },
      {
        description:
          'Small business owner? This is the retirement account for you, as it’s tax-deferred and contributions are made by the employer.',
        account_type_name: 'SEP IRA',
      },
      {
        description:
          'While less common, this tax-deferred account is typically offered by small business owners. It lets employees contribute to their retirement savings as part of their pre-tax compensation, and employers can contribute too.',
        account_type_name: 'SIMPLE IRA',
      },
    ],
    targetDate: 'When do you plan to use this money?',
    address: 'We do not accept a PO Box as a primary street address',
    assetAllocation: {
      goal: 'My Goal:',
      title: 'Here is our investment recommendation for you',
      description: "Based on your answers to the risk profile questions, here's how we recommend you invest your money:",
    },
    accountSelection: 'Which account would you like to open?',
    investmentProfile: {
      cashSweepVehicleChoice: 'Cash Sweep Vehicle Choice:',
      accountStatementDelivery: 'Account Statement Delivery:',
      tradeConfirmationDelivery: 'Trade Confirmation Delivery:',
    },
    beneConfirmSkipMessage: 'Are you sure you would like to skip adding beneficiaries?',
    ptcQuestion:
      'Is this account holder a control person of a publicly traded company? (Director, Officer or 10% Stock Owner)?',
    faiQuestion:
      'Are you, or anyone authorized to trade in your account, affiliated with, work with or work for a member firm of a Stock Exchange or FINRA?',
    spfQuestion:
      'Are you or is a member of your immediate family a current or former politically exposed person or public official (This includes U.S. and foreign individuals)?',
    custodianSkipBeneficiaryMessage: {
      TD: 'You will have to get in touch with your advisor if you want to add beneficiaries at a later point. \n Are you sure you want to skip adding beneficiaries now?',
      APEX: 'Are you sure you would like to skip adding beneficiaries?',
      DEFAULT: 'Are you sure you would like to skip adding beneficiaries?',
    },
    trustedContactConfirmSkipMessage: 'Are you sure you would like to skip adding a trusted contact?',
  },
  Transfer: {
    disableMoveMoney: {
      NewOpen: 'You need to open an account first before you can start moving money.',
      Pending: 'Your pending account status must be approved before you can start moving money.',
      'KYC/Sketch': 'Your account opening request must be approved before you can start moving money.',
    },
    deleteTransferRuleNotice:
      'This will delete your scheduled [frequency] [description] Are you sure you want to continue?',
    addNewBankAccountDisclaimer:
      'For security purposes, we may request additional information while linking a new bank account.',
    duplicateFileUploadError: 'You have already uploaded that file',
    fileNameToLongError: 'File name is too long',
    uploadLimitReachedError: 'You can not upload any more files',
    multipleIdentityDocumentsReqError: 'Two bank link verification documents required',
    oneIdentityDocumentReqError: 'A bank link verification document is required',
    generalUploadError: 'There was an error uploading the document(s)',
    bankLinkVerificationModalTitle: 'Bank Link Verification',
    linkVerificationSuccessTitle: 'Bank Link Verification Submitted',
    linkVerificationTypeInstructions: 'Please upload the following item(s):',
    linkVerificationVoidedCheck: 'A clear scanned copy of a voided check',
    linkVerificationFileTypeLabel: 'File must be JPEG / JPG / PNG or PDF format.',
    linkVerificationAffidavit: ' An affidavit of identity. Please download and complete the steps indicated on the form.',
    bankLinkVerificationModalBody:
      'For fraud prevention and security purposes we are requesting additional information to link a new bank account.',
    bankAccountDetailsAccountsLinkedLabel: 'Accounts linked to this bank account: [numLinked]',
    bankAccountDetailsTableHeading1: 'Account Name',
    bankAccountDetailsTableHeading2: 'Market Value',
    bankAccountDetailsModalTitle: 'Bank Account Details',
    bankAccountPendingVerification: 'Pending Verification',
    bankAccountNumLinkedLabel: '[numLinked] Account(s) Linked',
    bankAccountDocumentationRequired: 'Documentation Required',
    bankAccountPendingReview: 'Pending Review',
    linkVerificationFileSizeLabel: 'Each attachment can be up to 10MB.',
    linkVerificationAffidavitDownloadLabel: 'Download affidavit of identity.',
    linkVerificationAffidavitDownloadUrl: 'https://secure02.principal.com/publicvsupply/GetFile?fm=PAS56A&ty=VOP',
    bankAccountPendingMicroDeposit: 'Verify Bank Link',
  },
  Activity: {
    disableMoveMoney: {
      NewOpen: 'You need to open an account first before you can start moving money.',
      Pending: 'Your pending account status must be approved before you can start moving money.',
      'KYC/Sketch': 'Your account opening request must be approved before you can start moving money.',
    },
  },
  EditTransaction: {
    existingBankLink: 'This will cancel the existing bank link and any scheduled bank transfers.',
    createNewBankLink:
      'You are about to Create a new bank link for [brokerageAccountName] [brokerageAccountNumber] ([brokerageAccountType])',
    contributionLimit: {
      SEP: 'The maximum annual contribution limit to a SEP IRA is $56,000',
      others:
        'The standard annual contribution limit to a [regularAccountTypeName] is [regularAccountLimit]. The catch up limit is [catchUpAccountLimit]. IRS will impose penalty tax on the excess amount for each year it remains in the IRA. You can however choose to continue or change the amount.',
    },
    transferStartDateNotice:
      "You should see the funds in your account 5-7 business days from the transfer date you have selected.  We need to take a few days to make sure enough cash is available, then we'll get it sent over to the bank account",
    notFullyOpened:
      'It looks like your account is not fully set up.  Please give us some more time to have everything ready for you.',
    oneTimeTransferHelpText:
      'In case you want the option to make a contribution to the previous year then change the Frequency to One-Time.',
    withdrawalDisclaimer:
      'To submit a withdrawal of your total account balance, please call us [riaPhoneNum] to request the distribution. Any withdrawal request of your total account balance made online will not be processed.',
  },
  ConfirmTransaction: {
    confirmMessage:
      'You have set up a [transferFrequency] [type] of $[amount] from [fromName]  to [toName]. Is this correct?',
    successMessage:
      'Your [type] has been successfully set up.You should see the funds in your account [pendingDays] business days from your selected transfer date',
    notFullyOpened: 'Your account will be ready to fund shortly. Please try again in 15 minutes.',
    failMessage: 'Something went wrong',
  },
  AddUser: {
    agreeTermsErrorMessage: 'You must agree to the terms before proceeding',
  },
  ConfirmBankLinkPage: {
    successMessage: 'Your bank has been successfully linked.',
    successPendingIdentityMessage:
      'You have successfully initiated the process to link your [bankName] bank account to your [brokerageAccountName] account. You may be requested for additional documentation to successfully complete the bank link.',
  },
  withdrawal: {
    contributionLimit: {
      SEP: 'The maximum annual contribution limit to a SEP IRA is [regularAccountLimit]',
      others:
        'The standard annual contribution limit to a [regularAccountTypeName] is [regularAccountLimit]. The catch up limit is [catchUpAccountLimit]. IRS will impose penalty tax on the excess amount for each year it remains in the IRA. You can however choose to continue or change the amount.',
    },
    createNewBankLink:
      'You are about to create a new bank link for [brokerageAccountName] [brokerageAccountNumber] ([brokerageAccountType])',
    existingBankLink: 'This will cancel the existing bank link and any scheduled bank transfers.',
    transferStartDateNotice:
      "You should see the funds in your account 5-7 business days from the transfer date you have selected.  We need to take a few days to make sure enough cash is available, then we'll get it sent over to the bank account",
    withdrawalDisclaimer:
      'To submit a withdrawal of your total account balance, please call us [riaPhoneNum] to request the distribution. Any withdrawal request of your total account balance made online will not be processed.',
    oneTimeTransferHelpText:
      'In case you want the option to make a contribution to the previous year then change the Frequency to One-Time.',
    addNewBankAccountDisclaimer:
      'For security purposes, we may request additional information while linking a new bank account.',
  },
  LiquidationSuccessPage: {
    pageName: 'liquidationSuccessPage',
    successMessages: {
      DEFAULT:
        'You have successfully initiated for your [accountName] account to be liquidated and closed. You should see the complete account balance in your [bankName] Bank account in 5-7 business days.',
      CHECK:
        'You have successfully initiated for your [accountName] account to be liquidated and closed. You should receive a check for the complete account balance to your [addressType] on file.',
      BANK_NOT_VERIFIED:
        'You have successfully setup instructions for your [accountName] account to be liquidated and closed. You however, have a Bank link that needs to be verified. You should see the complete account balance in your [bankName] Bank account in 5-7 business days once your bank link is verified.',
    },
  },
  OverviewPage: {
    disableMoveMoney: {
      NewOpen: 'You need to open an account first before you can start moving money.',
      Pending: 'Your pending account status must be approved before you can start moving money.',
      'KYC/Sketch': 'Your account opening request must be approved before you can start moving money.',
    },
    deleteTransferRuleNotice:
      'This will delete your scheduled [frequency] [description] Are you sure you want to continue?',
    addNewBankAccountDisclaimer:
      'For security purposes, we may request additional information while linking a new bank account.',
    uploadLimitReachedError: 'You can not upload any more files',
    bankAccountDetailsAccountsLinkedLabel: 'Accounts linked to this bank account: [numLinked]',
    bankAccountDetailsTableHeading1: 'Account Name',
    bankAccountDetailsTableHeading2: 'Market Value',
    bankAccountDetailsModalTitle: 'Bank Account Details',
    bankAccountPendingVerification: 'Pending Verification',
    bankAccountNumLinkedLabel: '[numLinked] Account(s) Linked',
    bankAccountDocumentationRequired: 'Documentation Required',
    bankAccountPendingReview: 'Pending Review',
  },
  AccountsPage: {
    disableMoveMoney: {
      NewOpen: 'You need to open an account first before you can start moving money.',
      Pending: 'Your pending account status must be approved before you can start moving money.',
      'KYC/Sketch': 'Your account opening request must be approved before you can start moving money.',
    },
    deleteTransferRuleNotice:
      'This will delete your scheduled [frequency] [description] Are you sure you want to continue?',
    addNewBankAccountDisclaimer:
      'For security purposes, we may request additional information while linking a new bank account.',
    fileNameToLongError: 'File name is too long',
    uploadLimitReachedError: 'You can not upload any more files',
    duplicateFileUploadError: 'You have already uploaded that file',
    multipleIdentityDocumentsReqError: 'Two bank link verification documents required',
    oneIdentityDocumentReqError: 'A bank link verification document is required',
    generalUploadError: 'There was an error uploading the document(s)',
    bankLinkVerificationModalTitle: 'Bank Link Verification',
    linkVerificationSuccessTitle: 'Bank Link Verification Submitted',
    linkVerificationTypeInstructions: 'Please upload the following item(s):',
    linkVerificationVoidedCheck: 'A clear scanned copy of a voided check',
    linkVerificationAffidavit: ' An affidavit of identity. Please download and complete the steps indicated on the form.',
    linkVerificationFileTypeLabel: 'File must be JPEG / JPG / PNG or PDF format.',
    bankLinkVerificationModalBody:
      'For fraud prevention and security purposes we are requesting additional information to link a new bank account.',
    bankAccountDetailsAccountsLinkedLabel: 'Accounts linked to this bank account: [numLinked]',
    bankAccountDetailsTableHeading1: 'Account Name',
    bankAccountDetailsTableHeading2: 'Market Value',
    bankAccountDetailsModalTitle: 'Bank Account Details',
    bankAccountPendingVerification: 'Pending Verification',
    bankAccountNumLinkedLabel: '[numLinked] Account(s) Linked',
    bankAccountDocumentationRequired: 'Documentation Required',
    bankAccountPendingReview: 'Pending Review',
    linkVerificationFileSizeLabel: 'Each attachment can be up to 10MB.',
    linkVerificationAffidavitDownloadLabel: 'Download affidavit of identity.',
    linkVerificationAffidavitDownloadUrl: 'https://secure02.principal.com/publicvsupply/GetFile?fm=PAS56A&ty=VOP',
  },
  LiquidationLandingPage: [
    {
      title: 'Before you begin',
      order: 1,
      description:
        'Depending on your situation, your withdrawal may be taxed and/or subject to tax penalties    If you are looking to transfer funds to another account without liquidating the assets, please reach out to us for assistance',
      pageName: 'LiquidationLandingPage',
    },
    {
      title: 'What to expect in the process',
      order: 2,
      description:
        'You will select how you would like to receive the funds, either by direct deposit to your bank account or via check.If applicable, you will elect your federal and state tax withholding instructions.Upon submitting the request, the assets in your account will be traded to cash (liquidated) and the account will be closed.If this is your only open account, your login access will remain for up to 18 months before expiring. If you have other open accounts, your login access will be unaffected.',
      pageName: 'LiquidationLandingPage',
    },
    {
      title: 'Estimated time frame',
      order: 3,
      description:
        'Once your request has been submitted, the funds will usually be transferred from your account within 5-7 business days.Please note, certain types of holdings may require an additional 1-2 business days.',
      pageName: 'LiquidationLandingPage',
    },
  ],
  Transactions: {
    disableMoveMoney: {
      NewOpen: 'You need to open an account first before you can start moving money.',
      Pending: 'Your pending account status must be approved before you can start moving money.',
      'KYC/Sketch': 'Your account opening request must be approved before you can start moving money.',
    },
    deleteTransferRuleNotice:
      'This will delete your scheduled [frequency] [description] Are you sure you want to continue?',
    addNewBankAccountDisclaimer:
      'For security purposes, we may request additional information while linking a new bank account.',
    duplicateFileUploadError: 'You have already uploaded that file',
    fileNameToLongError: 'File name is too long',
    uploadLimitReachedError: 'You can not upload any more files',
    multipleIdentityDocumentsReqError: 'Two bank link verification documents required',
    oneIdentityDocumentReqError: 'A bank link verification document is required',
    generalUploadError: 'There was an error uploading the document(s)',
    bankLinkVerificationModalTitle: 'Bank Link Verification',
    linkVerificationSuccessTitle: 'Bank Link Verification Submitted',
    linkVerificationTypeInstructions: 'Please upload the following item(s):',
    linkVerificationVoidedCheck: 'A clear scanned copy of a voided check',
    linkVerificationFileTypeLabel: 'File must be JPEG / JPG / PNG or PDF format.',
    linkVerificationAffidavit: ' An affidavit of identity. Please download and complete the steps indicated on the form.',
    bankLinkVerificationModalBody:
      'For fraud prevention and security purposes we are requesting additional information to link a new bank account.',
    bankAccountDetailsAccountsLinkedLabel: 'Accounts linked to this bank account: [numLinked]',
    bankAccountDetailsTableHeading1: 'Account Name',
    bankAccountDetailsTableHeading2: 'Market Value',
    bankAccountDetailsModalTitle: 'Bank Account Details',
    bankAccountPendingVerification: 'Pending Verification',
    bankAccountNumLinkedLabel: '[numLinked] Account(s) Linked',
    bankAccountDocumentationRequired: 'Document Required',
    bankAccountPendingReview: 'Pending Review',
    linkVerificationFileSizeLabel: 'Each attachment can be up to 10MB.',
    linkVerificationAffidavitDownloadLabel: 'Download affidavit of identity.',
    linkVerificationAffidavitDownloadUrl: 'https://secure02.principal.com/publicvsupply/GetFile?fm=PAS56A&ty=VOP',
    bankAccountPendingMicroDeposit: 'Verify Bank Link',
  },
};
